module.exports = __webpack_public_path__ + "static/media/Mansion.05fc1fe2.svg";